import React from 'react'
import './register.less'
import { Modal } from 'antd';
const open = () => {
    return Modal.info({
        title: '法律声明及隐私权政策',
        okText: '确认',
        centered: true,
        width: 1000,
        keyboard: true,
        icon: '',
        className: 'xieyi_modal',
        maskClosable: true,
        footer: false,
        content: (<div class="WordSection1" >

        {/* <p><b><span>法律声明及隐私权政策</span></b></p> */}
        
        <p ><span  >&nbsp;</span></p>
        
        <p  align="right"><span>最近更新日期：<span >2020</span>年<span >7</span>月<span >13</span>日</span></p>
        
        <p  align="right"><span>生效日期：<span >2020</span>年<span >7</span>月<span >13</span>日</span></p>
        
        <p style={{margin:'20 0px'}}><b><span>提示条款</span></b></p>
        
        <p style={{margin:'20 0px'}}><span >您的信任对我们非常重要，我们深知用户信息安全的重要性，我们将按照法律法规要求，采取安全保护措施，保护您的用户信息安全可控。鉴此，物业云（或简称“我们”）制定本《法律声明及隐私权政策》（以下或简称“声明和政策”）并提醒您：<b>在使用物业云网站的各项服务前，请您务必仔细阅读并透彻理解本《法律声明和隐私权政策》，在确认充分理解并同意后方使用相关产品和服务。一旦您开始使用物业云服务，将被视为对本声明和政策内容的接受和认可。</b></span></p>
        
        <p style={{margin:'20 0px'}}><span >如对本声明和政策内容有任何疑问、意见或建议，</span><span>您可通过物业云的客服电话客服电话【<span >10101778</span>】或者添加物业云客服微信【<span >colourlife888</span>】</span><span>与我们联系。</span></p>
        
        <p style={{margin:'20 0px'}}><span>&nbsp;</span></p>
        
        <p style={{margin:'20 0px'}}><b><span>定义</span></b></p>
        
        <p style={{margin:'20 0px'}}><b><span >物业云网站：</span></b><b><span >【<span >http://cloud.colourlife.com</span>】</span></b><span >。</span></p>
        
        <p style={{margin:'20 0px'}}><b><span >物业云</span></b><span >：除非另有约定，指</span><span >深圳市彩生活网络服务有限公司（以下简称为彩网）为</span><span>物业云网站的经营者。</span></p>
        
        <p style={{margin:'20 0px'}}><b><span >用户信息</span></b><span >：用户信息是指您注册物业云网站账户，使用物业云的服务以及物业云为了向您提供服务，您提交的或者物业云收集的用户会员类信息，如姓名、联系方式等，具体详见隐私权政策第二条所述的信息。</span></p>
        
        <p style={{margin:'20 0px'}}><b><span >业务数据</span></b><span >：不同于用户信息，是指物业云的用户利用物业云的服务上传、下载、分发等通过物业云的技术服务处理的数据。</span></p>
        
        <p style={{margin:'20 0px'}}><span>&nbsp;</span></p>
        
        <p style={{margin:'20 0px'}}><b><span>法律声明</span></b></p>
        
        {/* <p style={{margin:'20 0px'}}><b><span style="font-size:13.5pt;font-family:
        &quot;微软雅黑&quot;, ><br>
        <br>
        </span></b></p> */}
        
        <p style={{margin:'20 0px'}}><b><span >一、权利归属</span></b></p>
        
        <p class="1" ><span>1.1.&nbsp;&nbsp;&nbsp;&nbsp;</span><span >物业云网站的<span >Logo</span>、“物业云”等文字、图形及其组合，以及物业云网站的其他标识、徽记、物业云服务的名称等为彩网及其关联公司在中国和其他国家的注册商标。未经彩网书面授权，任何人不得以任何方式展示、使用或做其他处理（包括但不限于复制、传播、展示、镜像、上传、下载），也不得向他人表明您有权展示、使用或做其他处理。</span></p>
        
        <p class="1" ><span>1.2.&nbsp;&nbsp;&nbsp;&nbsp;</span><span >物业云网站所有的产品、服务、技术与所有程序（以下或简称“技术服务”）的知识产权均归属于物业云或归其权利人所有。</span></p>
        
        <p class="1" ><span>1.3.&nbsp;&nbsp;&nbsp;&nbsp;</span><span >除非彩网另行声明，彩网拥有物业云在网站内发布文档等信息（包括但不限于文字、图形、图片、照片、音频、视频、图标、色彩、版面设计、电子文档）的所有权利（包括但不限于版权、商标权、专利权、商业秘密和其他所有相关权利）。未经彩网许可，任何人不得擅自使用如上内容（包括但不限于通过程序或设备监视、复制、转播、展示、镜像、上传、下载物业云网站内的任何内容）。被授权浏览、复制、打印和传播属于物业云网站内信息内容的，该等内容都不得用于商业目的且所有信息内容及其任何部分的使用都必须包括此权利声明。</span></p>
        
        <p style={{margin:'20 0px'}}><span>&nbsp;&nbsp;&nbsp;&nbsp;</span></p>
        
        <p style={{margin:'20 0px'}}><b><span >&nbsp;</span></b><b><span >二、责任限制</span></b></p>
        
        <p class="1" ><span>2.1.&nbsp;&nbsp;&nbsp;&nbsp;</span><span >物业云用户在物业云网站的论坛、社区以及云市场上，自行上传、提供、发布相关信息，包括但不限于用户名称、公司名称、
        联系人及联络信息，相关图片、资讯等，该等信息均由用户自行提供，物业云的用户须对其提供的任何信息依法承担全部责任。</span></p>
        
        <p class="1" ><span>2.2.&nbsp;&nbsp;&nbsp;&nbsp;</span><span >物业云网站上转载作品（包括论坛内容）出于传递更多信息之目的，并不意味物业云赞同其观点或证实其内容的真实性。</span></p>
        
        <p class="1" ><span>2.3.&nbsp;&nbsp;&nbsp;&nbsp;</span><span >物业云在此提示，您在使用物业云服务期间应当遵守中华人民共和国的法律，不得危害网络安全，不得利用物业云的服务从事他人侵犯名誉、隐私、知识产权和其他合法权益的活动。尽管有前述提示，物业云不对您使用物业云服务的用途和目的承担任何责任。</span></p>
        
        <p class="1" ><span>&nbsp;</span></p>
        
        <p style={{margin:'20 0px'}}><b><span >三、知识产权保护</span></b></p>
        
        <p style={{margin:'20 0px'}}><span >我们尊重知识产权，反对并打击侵犯知识产权的行为。</span><span >任何组织或个人认为物业云网站的网页（含<b><span >http://cloud.colourlife.com</span></b>网页内容以及客户端页面）内容（如转载文章、云市场服务商发布的商品信息等）可能侵犯其合法权益的，可以通过向物业云（<b><span >http://cloud.colourlife.com</span></b>）提出书面权利通知，物业云将在收到知识产权权利人合格通知后依法尽快处理。</span></p>
        
        <p style={{margin:'20 0px'}}><span>&nbsp;</span></p>
        
        <p style={{margin:'20 0px'}}><span>&nbsp;</span></p>
        
        {/* <p style={{margin:'20 0px'}}><b><span><br>
        <br>
        </span></b></p>
         */}
        <p style={{margin:'20 0px'}}><b><span>&nbsp;</span></b><b><span >隐私权政策</span></b></p>
        
        {/* <p style={{margin:'20 0px'}}><b><span style="font-size:13.5pt;font-family:
        &quot;微软雅黑&quot;, ><br>
        <br>
        </span></b></p> */}
        
        <p style={{margin:'20 0px'}}><span >物业云（以下或称为“我们”）尊重并保护用户信息，并且将以高度勤勉和审慎的义务对待这些信息。在您使用了物业云网站提供的服务时，我们将按照本隐私权政策收集、处理及披露您的信息。我们希望通过本隐私权政策向您清晰地介绍我们对您信息的处理方式，因此我们建议您完整地阅读本隐私权政策，以帮助您了解维护自己隐私权的方式。</span></p>
        
        <p style={{margin:'20 0px'}}><span >如果您有任何疑问、意见或建议，请通过物业云提供的各种联系方式与我们联系。</span></p>
        
        <p style={{margin:'20 0px'}}><span >本政策将帮助您了解以下内容：</span></p>
        
        <p style={{margin:'20 0px'}}><span >一、本协议的适用范围</span></p>
        
        <p style={{margin:'20 0px'}}><span >二、我们如何收集和使用您的用户信息</span></p>
        
        <p style={{margin:'20 0px'}}><span >三、我们如何共享、转让、公开披露您的用户信息</span></p>
        
        <p style={{margin:'20 0px'}}><span >四、用户业务数据和公开信息</span></p>
        
        <p style={{margin:'20 0px'}}><span >五、您如何管理您的用户信息</span></p>
        
        <p style={{margin:'20 0px'}}><span >六、我们如何使用<span >cookie</span>和同类技术</span></p>
        
        <p style={{margin:'20 0px'}}><span >七、我们如何保护和保存您的用户信息</span></p>
        
        <p style={{margin:'20 0px'}}><span >八、未成年人用户信息的特别约定</span></p>
        
        <p style={{margin:'20 0px'}}><span >九、隐私权政策的更新</span></p>
        
        <p style={{margin:'20 0px'}}><span >十、如何联系我们</span></p>
        
        <p style={{margin:'20 0px'}}><span>&nbsp;</span></p>
        
        <p style={{margin:'20 0px'}}><b><span>&nbsp;</span></b><b><span >一、<span >&nbsp;
        &nbsp; </span>本协议的适用范围</span></b></p>
        
        <p class="1" ><span>1.1.&nbsp;&nbsp;&nbsp;&nbsp;</span><span >本隐私权政策适用于物业云网站所有服务。服务包括向您提供页面浏览、网站登录服务，以及通过物业云网站向您提供的技术服务。</span></p>
        
        <p class="1" ><span>1.2.&nbsp;&nbsp;&nbsp;&nbsp;</span><span >本隐私权政策不适用于其他第三方向您提供的服务。例如，物业云云市场上的服务商依托云市场向您提供服务时，您向服务商提供的信息不适用本隐私权政策。</span></p>
        
        <p class="1" ><span>1.3.&nbsp;&nbsp;&nbsp;&nbsp;</span><span >需要特别说明的是，作为物业云的用户，若您利用物业云的技术服务，为您的用户再行提供服务，因您的业务数据属于您所有，您应当另行与您的用户约定隐私权政策。</span></p>
        
        <p style={{margin:'20 0px'}}><span>&nbsp;</span></p>
        
        <p style={{margin:'20 0px'}}><b><span >二、<span >&nbsp;&nbsp;&nbsp;&nbsp;</span>我们如何收集和使用您的用户信息</span></b></p>
        
        <p style={{margin:'20 0px'}}><b><span >（一）我们收集您的用户信息的情形</span></b></p>
        
        <p class="1" ><b><span>2.1.&nbsp;</span></b><b><span  >&nbsp;</span></b><b><span >帮助您成为我们的会员</span></b></p>
        
        <p style={{margin:'20 0px'}}><b><span>2.1.1.&nbsp;</span></b><b><span >当您在物业云网站创建账户时，您须向我们提供会员名，设置、确认您的登录密码，提供您在中华人民共和国境内手机号码。您提交的手机号码用于您注册、登录、绑定账户、密码找回时接受验证码，并且作为您与物业云指定的联系方式之一，用来接受相关业务通知（如新品上线、服务变更等）。</span></b></p>
        
        <p style={{margin:'20 0px'}}><b><span>2.1.2. &nbsp;</span></b><b><span >在您注册完成物业云账户后，您可以在账户“企业认证”一栏中继续填写您的信息，包括（</span></b><b><span  >1</span></b><b><span >）单位名称（如果您已完成实名认证，单位名称将会以您的实名认证信息为准）、证件类型、营业执照、工商注册号、法人代表、法人身份证号码<span >;</span>。</span></b><b><span 
        >您若不提供这些信息，将会影响您对某一具体技术服务的使用。您提供的信息，物业云可能会利用如上方式向您推广、宣传产品、邮寄业务通知或与您进行业务沟通。</span></b></p>
        
        <p style={{margin:'20 0px'}}><b><span>2.1.3.</span></b><b><span >如果您仅需使用物业云网站的浏览、搜索等基本服务，您不需要注册成为我们的会员及提供上述信息。</span></b></p>
        
        <p style={{margin:'20 0px'}}><b><span >2.1.<span class="msoIns"><ins cite="mailto:李%20玉华" datetime="2020-07-14T16:35">4</ins></span>.&nbsp;</span></b><b><span >如果您已经注册有物业云的，您可利用前述账号登录物业云的网站。您通过物业云登陆的，您仍需按照物业云提供的实名认证方式提交您的真实身份信息。我们会将依据与第三方的约定，在符合相关法律法规规定的前提下，使用您的这些用户信息。</span></b></p>
        
        <p style={{margin:'20 0px'}}><b><span>2.2.&nbsp;&nbsp;&nbsp;&nbsp;</span></b><b><span >向您提供技术服务</span></b></p>
        
        <p style={{margin:'20 0px'}}><b><span>2.2.1.</span></b><span  >&nbsp;</span><b><span >根据中华人民共和国法律，在您使用具体的技术服务时，您应通过您的账号提供您的真实身份信息。您通过物业云账号提供真实身份信息的，物业云为您提供了多种方式以协助您提供信息，您应根据您的身份属性选择适合的方式。如您通过企业对公账号方式进行实名认证的，您需向物业云提交您的企业注册地区、企业性质、企业名称和营业执照注册号，以及银行账户信息（包括开户行、银行账号和开户人）。物业云将以您提交的企业注册地区、企业性质、企业名称和营业执照注册号确认您的实名信息，物业云仅将您提供的银行账户信息（包括开户行、银行账号和开户人）作为实名认证时的打款账号。</span></b></p>
        
        <p style={{margin:'20 0px'}}><b><span>2.2.2.</span></b><b><span >在您使用服务过程中我们会收集以下的信息：</span></b></p>
        
        <p style={{margin:'20 0px'}}><span>2.2.2.1.&nbsp;</span><span >设备信息：我们会根据您在软件安装及使用中授予的具体权限，接收并记录您所使用的设备相关信息（例如设备型号、操作系统版本、设备设置、唯一设备标识符等软硬件特征信息）、设备所在位置相关信息（例如<span >IP</span>地址、<span >GPS</span>位置以及能够提供相关信息的<span >Wi-Fi</span>接入点、蓝牙和基站等传感器信息）。我们可能会将前面两类信息进行关联，以便我们能在不同设备上为您提供一致的服务。</span></p>
        
        <p style={{margin:'20 0px'}}><span>2.2.2.2.&nbsp;</span><span >日志信息：当您使用我们的网站或客户端提供的服务时，我们会自动收集您对我们服务的详细使用情况，作为有关网络日志保存。例如您的搜索查询内容、<span >IP</span>地址、浏览器的类型、电信运营商、使用的语言、访问日期和时间及您访问的网页记录等。</span></p>
        
        <p style={{margin:'20 0px'}}><b><span>2.2.2.3.&nbsp;</span></b><b><span >用户账户的支持信息：基于您使用物业云服务而产生的用户的咨询记录、报障记录和针对用户故障的排障过程（如通信或通话记录），物业云将通过记录、分析这些信息以便更及时响应您的帮助请求，以及用于改进服务。</span></b></p>
        
        <p style={{margin:'20 0px'}}><b><span>2.2.3.&nbsp;</span></b><b><span >我们在向您提供业务功能或具体服务时，我们会按照本政策以及相应的产品服务协议的约定收集、使用、存储、对外提供及保护您的用户信息；超出本政策以及相应的产品服务协议约定收集您的用户信息的，我们会另行向您说明信息收集的范围与目的，并征得您的同意后方收集提供相应服务所必要的您的信息；如您选择不提供前述信息，将会影响到您使用相应产品，但不会影响您使用物业云网站基本功能和其他产品。</span></b></p>
        
        <p style={{margin:'20 0px'}}><b><span >（二）我们使用您的用户信息的情形</span></b></p>
        
        <p style={{margin:'20 0px'}}><span><b>2.3.&nbsp;&nbsp;&nbsp;&nbsp;</b></span><b><span >我们出于如下目的，使用您提交以及我们收集的用户信息：</span></b></p>
        
        <p style={{margin:'20 0px'}}><span>2.3.1.&nbsp;</span><span >为了向您提供服务，我们会向您发送信息、通知或与您进行业务沟通，包括但不限于为保证服务完成所必须的验证码、使用服务时所必要的推送通知；</span></p>
        
        <p style={{margin:'20 0px'}}><span>2.3.2.&nbsp;</span><span >为了维护、改进服务，向您提供更符合您个性化需求的信息展示，我们可能将来自物业云网站某项服务的用户信息与来自其他项服务的信息结合起来，做出特征模型并进行用户画像，向您展示、推送信息和可能的商业广告，包括但不限于关于物业云产品的新闻以及市场活动及优惠促销信息、物业云合作第三方的推广信息，或其他您可能感兴趣的内容。如果您不想接收我们给您发送的商业性电子信息，您可通过短信提示回复退订或根据信息中提供的退订方式予以退订；</span></p>
        
        <p style={{margin:'20 0px'}}><span>2.3.3.&nbsp;</span><span >我们可能以用户信息统计数据为基础，设计、开发、推广全新的产品及服务；我们会对我们的服务使用情况进行统计，并可能会与公众或第三方分享这些统计信息，但这些统计信息不包含您的任何身份识别信息；</span></p>
        
        <p style={{margin:'20 0px'}}><span>2.3.4.&nbsp;</span><span >为提高您使用我们及我们关联公司、合作伙伴提供服务的安全性，确保操作环境安全与识别账号异常状态，保护您或其他用户或公众的人身财产安全免遭侵害，更好地预防钓鱼网站、欺诈、网络漏洞、计算机病毒、网络攻击、网络侵入等安全风险，更准确地识别违反法律法规或物业云相关协议、规则的情况，我们可能使用您的会员信息、并整合设备信息、有关网络日志以及我们关联公司、合作伙伴合法分享的信息，来判断您账户及交易风险、进行身份验证、安全事件的检测及防范，并依法采取必要的记录、审计、分析、处置措施；</span></p>
        
        <p style={{margin:'20 0px'}}><span>&nbsp;2.3.5.&nbsp;</span><span >如超出收集用户信息时所声称的目的，或者在超出具有直接或合理关联的范围使用用户信息前，我们会再次向您告知并征得您的明示同意</span><span >。</span></p>
        
        
        <p style={{margin:'20 0px'}}><b><span >三、<span >&nbsp;&nbsp;&nbsp;&nbsp;</span>我们如何共享、转让、公开披露您的用户信息</span></b></p>
        
        <p style={{margin:'20 0px'}}><b><span>3.1.&nbsp;</span></b><b><span >共享</span></b></p>
        
        <p style={{margin:'20 0px'}}><span>&nbsp;</span><span>我们不会与其他组织和个人共享您的用户信息，但以下情况除外：</span></p>
        
        <p style={{margin:'20 0px'}}><span>&nbsp;3.1.1.</span><span >在获取明确同意的情况下共享：获得您的明确同意后，我们会与其他方共享您的用户信息；</span></p>
        
        <p style={{margin:'20 0px'}}><span>&nbsp;3.1.2.</span><span >在法定情形下的共享：我们可能会根据法律法规规定、诉讼、仲裁解决需要，或按行政、司法机关依法提出的要求，对外共享您的用户信息；</span></p>
        
        <p style={{margin:'20 0px'}}><span>&nbsp;3.1.3.</span><span >为了促成交易或协助解决争议，某些情况下只有共享您的用户信息，才能促成交易或处理您与他人的纠纷或争议，例如，在物业云云市场上创建的某一交易中，如交易任何一方履行或部分履行了交易义务并提出信息披露请求的，物业云有权决定向该用户提供其交易对方的联络方式等必要信息，以促成交易的完成；</span></p>
        
        <p style={{margin:'20 0px'}}><span>&nbsp;3.1.4.</span><span >与授权合作伙伴共享：我们可能委托受信赖的合作伙伴来提供服务，因此我们可能会与合作伙伴共享您的某些用户信息，以提供更好的客户服务和优化用户体验。我们仅会出于合法、正当、必要、特定、明确的目的共享您的用户信息，并且只会共享提供服务所必要的用户信息。我们的合作伙伴无权将共享的用户信息用于任何其他用途。</span></p>
        
        <p style={{margin:'20 0px'}}><span >目前，我们的授权合作伙伴包括如下类型：供应商、服务提供商和其他合作伙伴。我们将信息发送给支持我们业务的供应商、服务提供商和其他合作伙伴，这些支持包括提供基础技术服务、提供咨询、分析等专业服务。</span></p>
        
        <p style={{margin:'20 0px'}}><span >对我们与之共享用户信息的公司、组织和个人，我们会与其签署严格的保密协议以及信息保护约定，要求他们按照我们的说明、本隐私权政策以及其他任何相关的保密和安全措施来处理用户信息。</span></p>
        
        <p style={{margin:'20 0px'}}><b><span>&nbsp;3.2.&nbsp;</span></b><b><span >转让</span></b></p>
        
        <p style={{margin:'20 0px'}}><span>&nbsp;</span><span>我们不会将您的用户信息转让给任何公司、组织和个人，但以下情况除外：</span></p>
        
        <p style={{margin:'20 0px'}}><span>&nbsp;3.2.1.&nbsp;</span><span >在获取明确同意的情况下转让：获得您的明确同意后，我们会向其他方转让您的用户信息；</span></p>
        
        <p style={{margin:'20 0px'}}><span>&nbsp;3.2.2.&nbsp;</span><span >在物业云与其他法律主体者发生合并、收购或破产清算情形，或其他涉及合并、收购或破产清算情形时，如涉及到用户信息转让，我们会要求新的持有您用户信息的公司、组织继续受本政策的约束，否则我们将要求该公司、组织和个人重新向您征求授权同意。</span></p>
        
        <p style={{margin:'20 0px'}}><b><span>&nbsp;3.3.&nbsp;</span></b><b><span >公开披露</span></b></p>
        
        <p style={{margin:'20 0px'}}><span>&nbsp; </span><span>我们仅会在以下情况下，公开披露您的用户信息：</span></p>
        
        <p style={{margin:'20 0px'}}><span>&nbsp; 3.3.1</span><span >． 获得您明确同意或基于您的主动选择，我们可能会公开披露您的用户信息；</span></p>
        
        <p style={{margin:'20 0px'}}><span>&nbsp; 3.3.2.&nbsp;</span><span >或为保护物业云平台及其关联公司用户或公众的人身财产安全免遭侵害，我们可能依据适用的法律或物业云平台相关协议、规则披露关于您的用户信息。例如，若您作为云市场服务商销售假货或盗版商品，我们可能会公开披露您的店铺主体信息与处罚情况。</span></p>
        
        <p style={{margin:'20 0px'}}><span>&nbsp;<b>3.4.&nbsp;</b></span><b><span >共享、转让、公开披露用户信息时事先征得授权同意的例外</span></b></p>
        
        <p style={{margin:'20 0px'}}><span>&nbsp; </span><span>以下情形中，共享、转让、公开披露您的用户信息无需事先征得您的授权同意：</span></p>
        
        <p style={{margin:'20 0px'}}><span>&nbsp; 3.4.1.&nbsp;</span><span >与国家安全、国防安全有关的；</span></p>
        
        <p style={{margin:'20 0px'}}><span>&nbsp; 3.4.2.&nbsp;</span><span >与公共安全、公共卫生、重大公共利益有关的；</span></p>
        
        <p style={{margin:'20 0px'}}><span>&nbsp; 3.4.3.&nbsp;</span><span >与犯罪侦查、起诉、审判和判决执行等有关的；</span></p>
        
        <p style={{margin:'20 0px'}}><span>&nbsp; 3.4.4.&nbsp;</span><span >出于维护您或其他个人的生命、财产等重大合法权益但又很难得到本人同意的；</span></p>
        
        <p style={{margin:'20 0px'}}><span>&nbsp; 3.4.5.&nbsp;</span><span >您自行向社会公众公开的个人信息；</span></p>
        
        <p style={{margin:'20 0px'}}><span>&nbsp; 3.4.6.</span><span >从合法公开披露的信息中收集个人信息的，如合法的新闻报道、政府信息公开等渠道。</span></p>
        
        <p style={{margin:'20 0px'}}><span>&nbsp;</span></p>
        
        <p style={{margin:'20 0px'}}><b><span>&nbsp;</span></b><b><span >四、<span >&nbsp;</span>用户业务数据和公开信息</span></b></p>
        
        <p style={{margin:'20 0px'}}><b><span>&nbsp;</span></b><b><span >不同于您的用户信息，对于用户业务数据和公开信息，物业云将按如下方式处理：</span></b></p>
        
        <p style={{margin:'20 0px'}}><b><span>&nbsp; 4.1.&nbsp;</span></b><b><span >用户业务数据</span></b></p>
        
        <p style={{margin:'20 0px'}}><span>&nbsp; 4.1.1.&nbsp;</span><span >您通过物业云提供的服务，加工、存储、上传、下载、分发以及通过其他方式处理的数据，均为您的用户业务数据，您完全拥有您的用户业务数据。物业云作为云服务提供商，我们只会严格执行您的指示处理您的业务数据，除按与您协商一致或执行明确的法律法规要求外，不对您的业务数据进行任何非授权的使用或披露。</span></p>
        
        <p style={{margin:'20 0px'}}><span>&nbsp;4.1.2.&nbsp;</span><span >您应对您的用户业务数据来源及内容负责，物业云提示您谨慎判断数据来源及内容的合法性。因您的用户业务数据内容违反法律法规、部门规章或国家政策而造成的全部结果及责任均由您自行承担。</span></p>
        
        <p style={{margin:'20 0px'}}><span>&nbsp;4.1.3.&nbsp;</span><span >根据您与物业云协商一致，物业云在您选定的数据中心存储用户业务数据。物业云恪守对用户的安全承诺，根据适用的法律保护用户存储在物业云数据中心的数据。</span></p>
        
        <p style={{margin:'20 0px'}}><b><span>&nbsp;4.2.&nbsp;</span></b><b><span >公开信息</span></b></p>
        
        <p style={{margin:'20 0px'}}><span>&nbsp;4.2.1.&nbsp;</span><span >公开信息是指您公开分享的任何信息，任何人都可以在使用和未使用物业云网站服务期间查看或访问这些信息。例如您在物业云开发者论坛发布的信息。</span></p>
        
        <p style={{margin:'20 0px'}}><span>&nbsp;4.2.2.&nbsp;</span><span >为使</span><span >用物业云网站服务，可能存在您必须公开分享的信息。例如应用市场为构建诚信交易环境，您的信用评价信息（星级、客户评价）需要被公开分享。若您是服务商（卖家），您应当根据适用的法律法规和物业云云市场规则的要求，公开分享企业或者自然人经营者的相关信息。</span></p>
        
        <p style={{margin:'20 0px'}}><span  >4.2.3.&nbsp;</span><span>在使用物业云网站的应用市场进行交易</span><span >时，您不可避免的要向交易对方或潜在的交易对方披露自己的个人信息，如联络方式或者邮政地址。请您妥善保护自己的个人信息，仅在必要的情形下向他人提供。您也可以通过我们的服务建立联系和相互分享。当您通过我们的服务创建交流、交易或分享时，您可以自主选择沟通、交易或分享的对象，作为能够看到您的联络方式、交流信息或分享内容等相关信息的第三方。如您发现自己的个人信息泄漏，尤其是您的账户或密码发生泄露，请您立即联络物业云客服，以便物业云采取相应措施。</span></p>
        
        <p style={{margin:'20 0px'}}><b><span>&nbsp;</span></b></p>
        
        <p ><b><span >五、<span >&nbsp;&nbsp;</span>您如何管理您的用户信息</span></b></p>
        
        <p style={{margin:'20 0px'}}><span>5.1.&nbsp; &nbsp;</span><span >您可以登录物业云网站“企业设置”查询、管理（变更、删除）使用物业云服务时而提交的企业认证信息（基本资料）和联系人信息。</span></p>
        
        <p style={{margin:'20 0px'}}><span  >5.2.&nbsp; &nbsp;</span><span>在以下情形中，您可以向我们提出删除用户信息的请求：</span></p>
        
        <p style={{margin:'20 0px'}}><span  >5.<span class="msoIns"><ins cite="mailto:李%20玉华" datetime="2020-07-14T16:59">2</ins></span>.1.&nbsp;</span><span >如果我们处理用户信息的行为违反法律法规；</span></p>
        
        <p style={{margin:'20 0px'}}><span  >5.<span class="msoIns"><ins cite="mailto:李%20玉华" datetime="2020-07-14T16:59">2</ins></span>.2.&nbsp;</span><span >如果我们收集、使用您的用户信息，却未征得您的明确同意；</span></p>
        
        <p style={{margin:'20 0px'}}><span  >5.<span class="msoIns"><ins cite="mailto:李%20玉华" datetime="2020-07-14T16:59">2</ins></span>.3.&nbsp;</span><span >如果我们处理个人信息的行为严重违反了与您的约定。</span></p>
        
        <p style={{margin:'20 0px'}}><span >&nbsp;</span><span >为保障安全，您可能需要提供书面请求，或以其他方式证明您的身份。我们可能会先要求您验证自己的身份，然后再处理您的请求。</span></p>
        
        <p style={{margin:'20 0px'}}><span  >5.<span class="msoIns"><ins cite="mailto:李%20玉华" datetime="2020-07-14T16:59">3</ins></span> </span><span>每个业务功能需要一些基本的用户信息才能得以完成（见本隐私权政策第二条）。除此之外，您可以在与物业云客服联系给予或收回您的授权同意。当您收回同意后，我们将不再处理相应的用户信息。<b>但您收回同意的决定，不会影响此前基于您的授权而开展的用户信息处理。</b></span></p>
        
        <p style={{margin:'20 0px'}}><span  >5.<span class="msoIns"><ins cite="mailto:李%20玉华" datetime="2020-07-14T16:59">4</ins></span> </span><span>您也可以自行在物业云网站“注销账号”页面（“管理控制台<span >-</span>账号管理<span >-</span>安全设置<span >-</span>注销账号”）提交账户注销申请。在您主动删除用户信息之后，我们将停止为您提供产品或服务，根据适用法律的要求删除您的用户信息。<span >&nbsp;</span></span></p>
        
        <p class="1" ><b><span >六、<span >&nbsp;&nbsp;</span>我们如何使用<span >Cookie&nbsp;</span>和同类技术</span></b></p>
        
        <p style={{margin:'20 0px'}}><span>6.1.&nbsp; &nbsp;</span><span >为确保网站正常运转、为您获得更轻松的访问体验、向您推荐您可能感兴趣的内容，我们会在您的计算机或移动设备上存储名为<span > Cookie </span>的小数据文件。<span >Cookie </span>通常包含标识符、站点名称以及一些号码和字符。物业云只能读取物业云提供的<span >cookies</span>。</span></p>
        
        <p style={{margin:'20 0px'}}><span>6.2.&nbsp; &nbsp;</span><span >借助于<span > Cookie</span>，能够存储您的偏好或购买清单中的商品等数据。当下一次您再次访问的时候，我们将显示您需要的信息；或由物业云通过<span >cookies</span>文件来辨识您的来源网站，以便物业云能追踪物业云的广告效果。</span></p>
        
        <p style={{margin:'20 0px'}}><span>&nbsp;6.3.&nbsp; &nbsp;</span><span >您可根据自己的偏好管理<span >Cookie</span>，您也可以清除计算机上保存的所有<span > Cookie</span>。大部分网络浏览器都设有阻止<span > Cookie </span>的功能。但如果您这么做，则需要在每一次访问我们的网站时更改用户设置。如需详细了解如何更改浏览器设置，请访问您使用的浏览器的相关设置页面。</span></p>
        
        <p style={{margin:'20 0px'}}><span>&nbsp;6.4.&nbsp; &nbsp;</span><span >除<span > Cookie </span>外，我们还会在网站上使用网站信标和像素标签等其他同类技术。例如，我们向您发送的电子邮件可能含有链接至我们网站内容的地址链接，如果您点击该链接，我们则会跟踪此次点击，帮助我们了解您的产品或服务偏好以便于我们主动改善客户服务体验。网站信标通常是一种嵌入到网站或电子邮件中的透明图像。借助于电子邮件中的像素标签，我们能够获知电子邮件是否被打开。如果您不希望自己的活动以这种方式被追踪，则可以随时从我们的寄信名单中退订。</span></p>
        
        <p style={{margin:'20 0px'}}><span>&nbsp;</span></p>
        
        <p style={{margin:'20 0px'}}><b><span >七、我们如何保护和保存您的用户信息</span></b></p>
        
        <p style={{margin:'20 0px'}}><span>7.1.&nbsp;&nbsp;&nbsp;&nbsp;</span><span >物业云非常重视您的信息安全。我们努力采取各种合理的物理、电子和管理方面的安全措施来保护您的用户信息。防止用户信息遭到未经授权访问、公开披露、使用、修改、损坏或丢失。我们会使用加密技术提高用户信息的安全性；我们会使用受信赖的保护机制防止用户信息遭到恶意攻击；我们会部署访问控制机制，尽力确保只有授权人员才可访问用户信息；以及我们会举办安全和隐私保护培训课程，加强员工对于保护用户信息重要性的认识。</span></p>
        
        <p style={{margin:'20 0px'}}><span>7.2.&nbsp;&nbsp;&nbsp;&nbsp;</span><span >我们会采取合理可行的措施，尽力避免收集无关的用户信息。我们只会在达成本政策所述目的所需的期限内保留您的用户信息，除非受到法律的允许。超出上述用户信息保存期限后，我们会对您的个人信息进行删除或匿名化处理。</span></p>
        
        <p style={{margin:'20 0px'}}><span>7.3.&nbsp;&nbsp;&nbsp;&nbsp;</span><span >请使用复杂密码，协助我们保证您的账号安全。我们将尽力保障您发送给我们的任何信息的安全性。</span></p>
        
        <p style={{margin:'20 0px'}}><span>7.4.&nbsp;&nbsp;&nbsp;&nbsp;</span><span >在不幸发生用户信息安全事件（泄露、丢失等）后，我们将按照法律法规的要求，及时向您告知：安全事件的基本情况和可能的影响、我们已采取或将要采取的处置措施、您可自主防范和降低风险的建议、对您的补救措施等。我们将及时将事件相关情况以邮件、信函、电话、推送通知等方式告知您，难以逐一告知用户信息主体时，我们会采取合理、有效的方式发布公告。</span></p>
        
        <p style={{margin:'20 0px'}}><span>7.5.&nbsp; &nbsp;</span><span >同时，我们还将按照监管部门要求，上报用户信息安全事件的处置情况。</span></p>
        
        <p style={{margin:'20 0px'}}><span>7.6.&nbsp; &nbsp;</span><span >我们将收集到的您的用户信息存放在中华人民共和国境内，如在符合适用法律规定的情形下因业务需要向境外传输个人信息的，我们会事先征得您的同意，并向您告知用户信息出境的目的、接收方、安全保障措施、安全风险等情况。</span></p>
        
        <p style={{margin:'20 0px'}}><span>&nbsp;7.7.&nbsp; &nbsp;</span><span >如出现物业云产品和服务停止运营的情形，我们会采取合理措施保护您用户信息安全，包括及时停止继续收集用户信息的活动；停止运营的通知将以逐一送达或公告的形式通知用户；并对所持有的个人信息进行删除或匿名化处理等。</span></p>
        
        <p style={{margin:'20 0px'}}><span>&nbsp;</span></p>
        
        <p style={{margin:'20 0px'}}><b><span>&nbsp;</span></b><b><span >八、未成年人用户信息的特别约定</span></b></p>
        
        <p style={{margin:'20 0px'}}><span>&nbsp;8.1. </span><span >我们主要面向成人提供产品和服务。如您为未成年人，我们要求您请您的父母或监护人仔细阅读本隐私权政策，并在征得您的父母或监护人同意的前提下使用我们的服务或向我们提供信息。</span></p>
        
        <p style={{margin:'20 0px'}}><span>&nbsp;8.2. </span><span>对于经父母或监护人同意使用我们的产品或服务而收集未成年人个人信息的情况，我们只会在法律法规允许、父母或监护人明确同意或者保护未成年人所必要的情况下使用、共享、转让或披露此信息。</span></p>
       
        
        <p style={{margin:'20 0px'}}><b><span >九、隐私权政策的更新</span></b></p>
        
        <p style={{margin:'20 0px'}}><span>&nbsp;9.1.&nbsp; &nbsp;</span><span >我们的隐私权政策可能修订。</span></p>
        
        <p style={{margin:'20 0px'}}><span>&nbsp;9.2.</span><span  >&nbsp;
        &nbsp;</span><span >未经您明确同意，我们不会限制您按照本隐私权政策所应享有的权利。我们会在</span><span ><b><span  ><span >专门页面</span></span></b></span><span>上发布对隐私权政策所做的任何修订。</span></p>
        
        <p style={{margin:'20 0px'}}><span>&nbsp;9.3.&nbsp; &nbsp;</span><span >对于重大修订，我们还会提供更为显著的通知（包括对于某些服务，我们会通过网站公示的方式进行通知甚至向您提供弹窗提示，说明隐私权政策的具体变更内容）。</span></p>
        
        <p style={{margin:'20 0px'}}><span>&nbsp;9.4.&nbsp; &nbsp;</span><span >本政策所指的重大变更包括但不限于：</span></p>
        
        <p style={{margin:'20 0px'}}><span>&nbsp;9.4.1.&nbsp;</span><span >我们的服务模式发生重大变化。如处理用户信息的目的、处理的用户信息类型、用户信息的使用方式等；</span></p>
        
        <p style={{margin:'20 0px'}}><span>&nbsp;9.4.2.&nbsp;</span><span >我们在控制权、组织架构等方面发生重大变化。如业务调整、破产并购等引起的所有者变更等；</span></p>
        
        <p style={{margin:'20 0px'}}><span>&nbsp;9.4.3.</span><span >用户信息共享、转让或公开披露的主要对象发生变化；</span></p>
        
        <p style={{margin:'20 0px'}}><span>&nbsp;9.4.4.&nbsp;</span><span >您参与用户信息处理方面的权利及其行使方式发生重大变化；</span></p>
        
        <p style={{margin:'20 0px'}}><span>&nbsp; 9.4.5.&nbsp;</span><span >我们负责处理用户信息安全的责任部门、联络方式及投诉渠道发生变化时；</span></p>
        
        <p style={{margin:'20 0px'}}><span>&nbsp; 9.4.6.&nbsp;</span><span >用户信息安全影响评估报告表明存在高风险时。</span></p>
        
        <p style={{margin:'20 0px'}}><span>&nbsp; </span><span>我们还会将本隐私权政策的历史版本在</span><span  >
         <b><span  ><span >网站专门页面</span></span></b></span><span>存档，</span><span >供您查阅。</span></p>
        
        <p class="1" ><span>&nbsp;</span></p>
        
        <p style={{margin:'20 0px'}}><b><span>&nbsp;</span></b><b><span >十、如何联系我们</span></b></p>
        
        <p style={{margin:'20 0px'}}><span  >&nbsp;</span><span>您对本声明和政策内容有任何疑问和意见，或者您对物业云对本隐私权政策的实践以及操作上有任何疑问和意见，您可通过物业云的工单、建议提交平台（<span >http://cloud.colourlife.com</span>）或添加物业云客服微信【<span >colourlife888</span>】与我们联系。</span></p>
        
        <p class="MsoNormal"><span >&nbsp;</span></p>
        
        </div>)
    })
}
export default open;



// WEBPACK FOOTER //
// ./src/pages/register/ysxieyi.jsx